import EpicCsvEntry from '../../../model/EpicCsvEntry';
import { formatEpicsAndTasks, formatTaskDescriptionColumn } from '../../utils/CsvFormatter';

export const EpicCsvFormat: Array<{ header: string; value: (e: EpicCsvEntry) => any }> = [
  {
    header: 'Epic order',
    value: (i) => i.epicOrder,
  },
  {
    header: 'Epic Id',
    value: (i) => i.epicId,
  },
  {
    header: 'Epic title',
    value: (i) => formatEpicsAndTasks(i.epicTitle),
  },
  {
    header: 'Epic description',
    value: (i) => formatEpicsAndTasks(i.epicDescription),
  },
  {
    header: 'Story order',
    value: (i) => i.taskOrder,
  },
  {
    header: 'Story Id',
    value: (i) => i.taskId,
  },
  {
    header: 'Story name',
    value: (i) => formatEpicsAndTasks(i.taskName),
  },
  {
    header: 'Story description',
    value: (i) => formatEpicsAndTasks(i.taskDescription),
  },
  {
    header: 'Story skills',
    value: (i) => i.taskSkills,
  },
];
